export default __webpack_public_path__ + "static/media/240_F_443956484_YbGZYCLvZC0f6v2kBpNLGjpO87fCm7SI.79cdce68.jpg";